import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const viewPlanList = (planData, showLoader = true) => {
  return async (dispatch) => {
    try {
      dispatch({ type: "GET_SUBSCRIPTION_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/subscription-plan/list`,
        planData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_SUBSCRIPTION_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_SUBSCRIPTION_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_SUBSCRIPTION_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      if(showLoader) {
        dispatch({ type: "STOP_LOADING" });
      }
    }
  };
};

export const addMorePlan = (Data, onSuccess) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "ADD_PlAN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.post(
        `${BASE_URL}/subscription-plan/add`,
        Data,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "ADD_PLAN_SUCCESS", payload: data });
        toast.success("Added Successfully!");
        onSuccess();
      } else {
        dispatch({ type: "ADD_PLAN_FAIL", payload: data });
        toast.error("Something went wrong!!");
      }
    } catch (error) {
      dispatch({ type: "ADD_PLAN_FAIL", payload: error.message });
      toast.error("Something went wrong!!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const viewCurrentPlan = (id) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_CURRENT_PlAN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/subscription-plan/view/${id}`,

        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_CURRENT_PLAN_SUCCESS", payload: data });
        toast.success("viewed Successfully!");
        return data;
      } else {
        dispatch({ type: "VIEW_CURRENT_PLAN_FAIL", payload: data });
        toast.error("Something went wrong!!");
      }
    } catch (error) {
      dispatch({ type: "VIEW_CURRENT_PLAN_FAIL", payload: error.message });
      toast.error("Something went wrong!!");
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const editPlanReducer = (teamData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "EDIT_PLAN_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/staff/alllist`,
        teamData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "EDIT_PLAN_SUCCESS", payload: data });
      } else {
        dispatch({ type: "EDIT_PLAN_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "EDIT_PLAN_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
